import { Injectable } from '@angular/core';

import { Event, SubscriptionHandler } from '@mirage-projects/communication-library';
import { EXTERNAL_COMMUNICATION_EVENTS, ExternalCommunicationService, MessageEvent } from '@mirage-projects/cw-commons';

/**
 * Handles external message events related to CRP1 import process
 */
@Injectable({
    providedIn: 'root',
})
export class CRP1ImportSdService {
    constructor(private externalCommunicationService: ExternalCommunicationService) {}

    /**
     * Sends an event to open the file dialog and request the contents of index.json file
     */
    openFileDialog(): Promise<void | MessageEvent> {
        return this.externalCommunicationService
            .sendEvent(EXTERNAL_COMMUNICATION_EVENTS.ACTION_GET_FILE_CONTENTS_REQUEST, { file: 'index.json' })
            .catch(() => console.log('error sending event: receiver not implemented yet'));
    }

    /**
     * Subscribes to the response event once the open file dialog folder has been selected.
     */
    onGetFileContentsResponse(): SubscriptionHandler {
        return this.externalCommunicationService.onEvents(EXTERNAL_COMMUNICATION_EVENTS.ACTION_GET_FILE_CONTENTS_RESPONSE);
    }

    /**
     * Sends an event to request copying and compressing the provided files.
     * @param files - The files to be copied and compressed.
     */
    copyAndCompressFiles(files: unknown): Promise<void | MessageEvent> {
        return this.externalCommunicationService
            .sendEvent(EXTERNAL_COMMUNICATION_EVENTS.ACTION_COPY_AND_COMPRESS_FILES_REQUEST, { files })
            .catch(() => console.log('error sending event: receiver not implemented yet'));
    }

    /**
     * Subscribes to the response event triggered when the copy and compress operation is completed.
     * @param functionHandler - The function to handle the received event.
     */
    onCompressedResponse(functionHandler: (event: Event) => void): SubscriptionHandler {
        return this.externalCommunicationService
            .onEvents(EXTERNAL_COMMUNICATION_EVENTS.ACTION_COPY_AND_COMPRESS_FILES_RESPONSE)
            .subscribe(functionHandler);
    }
}
